import { type MutableRefObject, useCallback, useEffect } from 'react'

import { SttMessageType } from '../utils/sttMessageTypes'

export const useFocusRestore = (
  isContextMenuOpen: boolean,
  prevActiveElementRef: MutableRefObject<HTMLElement | null>
) => {
  // Track last focused element before the context menu opens
  useEffect(() => {
    const onClick = () => {
      if (isContextMenuOpen) return
      prevActiveElementRef.current = document.activeElement as HTMLElement
    }
    document.addEventListener('click', onClick)
    return () => document.removeEventListener('click', onClick)
  }, [isContextMenuOpen, prevActiveElementRef])

  // While context menu is open, prevent mousedown from blurring dropdown inputs
  useEffect(() => {
    if (!isContextMenuOpen) return
    const onMouseDown = (e: MouseEvent) => e.preventDefault()
    document.addEventListener('mousedown', onMouseDown, true)
    return () => document.removeEventListener('mousedown', onMouseDown, true)
  }, [isContextMenuOpen])

  const restoreFocus = useCallback(() => {
    const el = prevActiveElementRef.current
    if (!el) return
    if (el instanceof HTMLIFrameElement) {
      el.focus({ preventScroll: true })
      el.contentWindow?.postMessage(
        { type: SttMessageType.RestoreFocus },
        process.env.REACT_APP_CONTAINER_DOMAIN!
      )
    } else {
      el.focus({ preventScroll: true })
    }
  }, [prevActiveElementRef])

  return { restoreFocus }
}
